angular
  .module("myApp")
  .controller("OrganizationListController", ($scope, $state, Dialog, OrganizationNew) => {
    $scope.view = "uznemums_list"
    $scope.gridOptions = {
      filtersUrl: "pages/org/org-filter.html",
      defaultFilters: {},
      initialFilters: {},
      noDataLabel: "Nav atrasta neviena organizācija.",
      rowClick: (row) => {
        if (row.id) {
          return $state.go("app.organization.edit", {
            id: row.id,
          })
        } else {
          return $state.go("app.organization.new")
        }
      },
      buttons: [
        {
          label: "Izveidot jaunu uzņēmumu",
          class: "btn-success",
          icon: "fa-plus",
          click: () =>
            Dialog.dialog("pages/dialogs/org.org-new.form.html", {}, (obj) => {
              const pp = new OrganizationNew(obj)
              return pp.$create(() =>
                $state.go("app.organization.edit", {
                  id: pp.id,
                })
              )
            }),
        },
      ],
    }
  })
  .controller(
    "OrganizationEditController",
    function (
      $scope,
      $stateParams,
      uuiData,
      $controller,
      Dialog,
      Codifiers,
      OrganizationAddUser,
      OrganizationRemoveUser
    ) {
      var uznemums_id
      $controller("BaseEditController", {
        $scope: $scope,
      })
      $scope.dto_view = "uznemums_editable"
      $scope.kla = Codifiers.kla
      $scope.users = void 0
      uznemums_id = $stateParams.id
      $scope.reloadUsers = () => {
        $scope.users = uuiData.list("uzn_lietotaji_list", {
          uznemums_id: uznemums_id,
        })
      }
      $scope.afterLoad = () => $scope.reloadUsers()
      $scope.reload()
      $scope.addUser = () =>
        this.editUser({
          ir_aktivs: true,
          uzn_loma: "DARBINIEKS",
          existing: false,
          pwd_mode: "email",
        })
      $scope.editUser = (u) => {
        u.existing = true
        u.pwd_mode = "none"
        return this.editUser(u)
      }

      this.editUser = (u) => {
        u.orig_epasts = u.epasts
        u.orig_existing = u.existing
        u.orig_pwd_mode = u.pwd_mode
        u.ev_autofill = () => {
          if (u.epasts === u.orig_epasts) {
            u.existing = u.orig_existing
            u.pwd_mode = u.orig_pwd_mode
            return true
          } else {
            u.existing = false
            u.pwd_mode = "email"
          }
          if (!u.epasts) {
            return true
          }
          uuiData.list(
            "lietotajs_autofill",
            {
              epasts: u.epasts,
            },
            (l) => {
              u.existing = true
              u.pwd_mode = "none"
              if (l.length === 0) {
                return
              }
              u.vards = l[0].vards
              u.uzvards = l[0].uzvards
              u.telefons = l[0].telefons
              u.personas_kods = l[0].personas_kods
              u.amats = l[0].amats
              u.ir_aktivs = l[0].ir_aktivs
            }
          )
          return true
        }
        return Dialog.dialog("pages/dialogs/org.add-user.form.html", u, (user, action) => {
          if (action === "save") {
            user.id = uznemums_id
            const a = new OrganizationAddUser(user)
            return Dialog.finish(a, () => {
              user.existing = void 0
              $scope.reloadUsers()
            })
          } else if (action === "delete") {
            const a = new OrganizationRemoveUser({
              id: uznemums_id,
              adm_lietotajs_id: user.adm_lietotajs_id,
              epasts: user.epasts,
            })
            return Dialog.finish(a, $scope.reloadUsers)
          }
        })
      }
    }
  )
